
import dayjs from 'dayjs'
import 'dayjs/locale/th'
import './ChangeLog.css'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import React, { useState, useEffect } from 'react';
import logo from '../res/img/AMO_Logo.png';
import { Grow, Box, Typography, List, ListItem, ListItemIcon, ListItemText, Divider } from '@material-ui/core';
import AddBoxRoundedIcon from '@material-ui/icons/AddBoxRounded';

function ChangeLog() {
    dayjs.extend(buddhistEra)   

    const [step, setStep] = useState(0);
    const [link, setLink] = useState(null);
    const [show, setShow] = useState(true);
    // const [releaseNote, setReleaseNote] = useState([]);
    const releaseNote = [
        {
            "version": "v2.2.2",
            "date": "2025-02-17",
            "changes":[
                "ปรับการเรียงลำดับประเภทจุดสนใจในหน้าแผนที่ให้เป็นระเบียบมากขึ้น บน Center และมือถือ ",
                "ปรับปรุงวิธีคำนวณการเรียกดูพิกัดลาดตะเวนย้อนหลังแบบใหม่ ให้สามารถแสดงข้อมูลได้อย่างละเอียดมากยิ่งขึ้น ",
                "เพิ่มความสามารถในการเรียกดูพิกัดลาดตะเวนย้อนหลังในระดับชั่วโมง เพื่อให้สามารถติดตามและวิเคราะห์เส้นทางได้อย่างละเอียดมากขึ้น ",
                "ปรับ UI โหมดป้ายชื่อในหน้าแผนที่ เพื่อให้สามารถแสดงข้อความได้ครบถ้วนและชัดเจนมากยิ่งขึ้น ",
                "ภารกิจ เพิ่มจำนวนเจ้าหน้าที่สูงสุดจากเดิม 400 คน เป็น 600 คน เพื่อรองรับภารกิจที่มีขนาดใหญ่ขึ้นและเพิ่มประสิทธิภาพในการบริหารจัดการเจ้าหน้าที่ภายในระบบ ",
                "แก้ไขปัญหาและปรับปรุง ฟีเจอร์ย่อยต่าง ๆ เพื่อให้ระบบทำงานได้อย่างราบรื่นและมีเสถียรภาพมากขึ้น ",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.2.1",
            "date": "2025-01-06",
            "changes":[
                "ข่าวสาร เพิ่มประเภทข่าว \"แจ้งเตือน\"",
                "ปรับปรุงการเเสดงผลของผู้ประกาศข่าว บนมือถือ",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.2.0",
            "date": "2024-12-11",
            "changes":[
                "เพิ่มฟีเจอร์ ดูกล้อง CCTV บนมือถือเเละ Center ",
                "เพิ่มฟีเจอร์ Presentation Marker บน Center ",
                "เพิ่มฟีเจอร์ การเเบ่งประเภทสถานะบุคคลและยานพาหนะ บน Center ",
                "เพิ่มฟีเจอร์ การตรวจสอบกลุ่มเป้าหมายอัตโนมัติ หลังจากบันทึกบุคคลหรือยานพาหนะ บนมือถือ ",
                "เพิ่มฟีเจอร์ ประวัติการใช้งาน (การค้นหา, การเเก้ไข, การพบเจอ, การเพิ่ม ของบุคคลและยานพาหนะ) บนมือถือ ",
                "ไอคอนเจ้าหน้าที่ เพิ่มการเเสดงค่าความคลาดเคลื่อนของพิกัด ",
                "เพิ่มคำอธิบายสัญลักษณ์ของไอคอนเจ้าหน้าที่  ",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.15",
            "date": "2024-10-26",
            "changes":[
                "ปรับปรุงประสิทธิภาพการใช้งานของ โหมดออฟไลน์ บนมือถือ",
                "ปรับปรุงการเเสดงผลของการ ดูถ่ายทอดสดย้อนหลัง บน Tablet",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.14",
            "date": "2024-10-23",
            "changes":[
                "ปรับปรุงประสิทธิภาพการเรียกดูของ “เหตุการณ์” ในหน้าแผนที่บนมือถือ",
                "ปรับปรุงการเเสดงผลในโหมดแนวนอนของ Tablet ให้ดียิ่งขึ้น ",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.13",
            "date": "2024-10-22",
            "changes":[
                "ปรับปรุงประสิทธิภาพการใช้งานในโหมดเเนวนอนของ Tablet ให้ดียิ่งขึ้น",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.12",
            "date": "2024-09-22",
            "changes":[
                "เพิ่มฟีเจอร์ให้สามารถแก้ไขเส้นวาดหรือเพิ่มรายการเส้นวาดย่อยได้ บนมือถือ",
                "เพิ่ม shape ขอบเขตสถานีตำรวจ และพื้นที่รับผิดชอบของแต่ละหน่วยลงในระบบ AMO",
                "หน้าแผนที่ ปรับเปลี่ยนสีของขอบเขตจังหวัด อำเภอ และตำบล ให้ดูเด่นชัดขึ้นพร้อมจัดวางการแสดงผลของชื่อให้เหมาะสม",
                "การ Handle เคลียร์ค่า cache ของแผนที่ทหารบน Center และมือถือ",
                "หน้าแผนที่ เพิ่มปุ่มเคลียร์ค่า cache แผนที่ทหารให้ผู้ใช้งานสามารถเลือกเคลียร์ได้เองบน Center",
                "เพิ่มประสิทธิภาพการแสดงผลของจุดสนใจให้เหมาะสมครอบคลุมทุกระดับซูมบนมือถือ",
                "แผนที่ดาวเทียม ปรับเปลี่ยนสีช่องของ MGRS หลัก 100 m และ 1 km จากเดิมที่สังเกตได้ค่อนข้างยาก",
                "การปรับแก้ Info Windows ที่เเสดงผิดปกติ เนื่องจากการอัปเดตของ google",
                "ห้องแชท เพิ่มฟีเจอร์เมื่อเลือกพิกัดที่มีการแชร์ในห้องแชท ให้นำไปยังหน้าแผนที่หลักทันที",
                "ปรับปรุงกระบวนการเบื้องหลังของการแสดงแจ้งเตือนให้อัปเดตตัวแอปพลิเคชัน AMO บนระบบปฏิบัติการ Android",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.11",
            "date": "2024-08-07",
            "changes":[
                'แผนที่ยุทธการ : หน้าแผนที่ เพิ่มการคัดกรองให้สามารถเลือก "รวมหน่วยใต้สังกัด" ได้บน Center',
                "อัปเดตแผนที่ทหาร 1 : 50000 ให้เป็นปัจจุบันมากขึ้น",
                "ปรับปรุงประสิทธิภาพการทำงานของปุ่มต่าง ๆ บนเครื่อง Android ให้ใช้งานกับ AMO ให้ดียิ่งขึ้น",
                "อัปเดตระบบหลังบ้านเกี่ยวกับหน้าต่างข้อความแจ้งเตือนในกรณีต่าง ๆ ให้ครอบคลุมการใช้งานมากยิ่งขึ้น ",
                "เพิ่มประสิทธิภาพการแสดงผลของจุดสนใจในหน้าแผนที่บน Center",
                "เพิ่มการรองรับไฟล์ภาพสกุล heif สำหรับเครื่อง iOS",
                "ปรับปรุงการทำงานของระบบโดยรวมให้มีประสิทธิภาพมากยิ่งขึ้น",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.10",
            "date": "2024-06-21",
            "changes":[
                "เปลี่ยนแปลงคำที่ใช้เรียกฟีเจอร์การใช้งานในหน้าต่าง ๆ บน Center ให้ชัดเจนและเข้าใจง่ายมาก",
                "เปลี่ยนแปลงคำที่ใช้เรียกฟีเจอร์การใช้งานในหน้าต่าง ๆ บนมือถือ ให้ชัดเจนและเข้าใจง่ายมากขึ้น",
                "หน้าข้อมูลรอตรวจสอบ (ฝั่ง Center) ในส่วนของหน้าต่างเพิ่มบุคคล ปรับตำแหน่งของช่องกรอกรายละเอียดบุคคลให้อยู่ในตำแหน่งที่เหมาะสม พร้อมเพิ่มช่องกรอกรายละเอียดบุคคล ซึ่งสามารถเชื่อมโยงกับข้อมูลที่ส่งมาจากฝั่งมือถือได้",
                "หน้ารายละเอียดเจ้าหน้าที่ (ฝั่ง Center) ปรับตำแหน่งการเรียงลำดับฟีเจอร์",
                "เพิ่มขีดความสามารถในการเรียกดูข้อมูล IPB บนหน้าแผนที่ให้มีประสิทธิภาพยิ่งขึ้น (Center)",
                "เพิ่มประสิทธิภาพทำงานของฟีเจอร์ติดตามบุคคลหน้าแผนที่ให้ทำงานได้ดียิ่งขึ้น (Center)",
                "ข้อมูลส่วนตัวของเจ้าหน้าที่ ในหัวข้อข้อมูลเพิ่มเติม (ฝั่งมือถือ) เพิ่มการแนะแนวการกรอกข้อมูลเพื่อให้เจ้าหน้าที่สามารถใช้งานได้สะดวกยิ่งขึ้น",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.9",
            "date": "2024-05-18",
            "changes":[
                "อัปเดตเวอร์ชัน Google Map เพื่อเพิ่มประสิทธิภาพการทำงานของหน้าแผนที่ (สำหรับมือถือ Android)",
                "เพิ่มประสิทธิภาพในการล็อกอินเข้าสู่ระบบ (มือถือ)",
                "เพิ่มความแม่นยำในการค้นใบหน้าบุคคล (ทั้ง Center และมือถือ)",
                "เพิ่มประสิทธิภาพในการการดาวน์โหลดแผนที่เพื่อวาดแผนยุทธการให้รองรับมาตราส่วนของจอภาพได้หลากหลายขึ้น (Center)",
                "ปรับปรุงการทำงานของการแก้ไขข้อมูลบัตรประชาชนให้สะดวกต่อการใช้งานมากขึ้น (มือถือ)"
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.8",
            "date": "2024-03-08",
            "changes":[
                "ศูนย์ควบคุม รายละเอียดข่าวสาร เพิ่มช่อง “หน่วยงานผู้ประกาศข่าว” สำหรับกรณีที่ไม่ต้องการใช้ชื่อของหน่วยผู้สร้าง หรือเป็นการสร้างข่าวให้หน่วยอื่น",
                "ข่าวสารบนมือถือ ปรับการแสดงผลหน่วยงานของข่าวสารจากการแสดงหน่วยงานที่สร้าง เป็น หน่วยงานผู้ประกาศข่าว ที่เลือกไว้",
                "ปรับปรุงสิทธิภาพการบันทึกรูปภาพบุคคลผ่านมือถือให้ดียิ่งขึ้น",
                "เพิ่มป้าย “สนธิกำลัง” สำหรับภารกิจที่มีการสนธิกำลังกันระหว่างหน่วย (Operator ต่างหน่วยงานกันอย่างน้อย 1 หน่วยงานที่อยู่ในภารกิจเดียวกัน) ทั้งบน Center และมือถือ",
                "เพิ่มป้ายการแจ้งเตือนภารกิจ “ใหม่”และ “อัปเดต” สำหรับ Operator ที่ถูกเชิญเข้าภารกิจหรือภารกิจที่มีการอัปเดตใหม่ให้ Operator ทราบ",
                "ปรับปรุงประสิทธิภาพการเพิ่มข้อมูลบุคคลเข้าระบบบนมือถือให้ดียิ่งขึ้น",
                "ปรับการแสดงผล ชื่อแสดงในแผนที่บรรทัด 1 , ชื่อแสดงในแผนที่บรรทัด 2 ให้เหมือนกันทั้งระบบ",
                "หน้าผลการค้นหาบุคคล ปรับปรุงประสิทธิภาพการแสดงผลลัพธ์ให้ดียิ่งขึ้น",
                "ข้อมูลส่วนตัวเจ้าหน้าที่ เพิ่มเงื่อนไขการกรอกจำนวนข้อความของช่องข้อมูลเพิ่มเติมได้สูงสุด 2,500 ตัวอักษร ทั้งบน Center และมือถือ",
                "ดูประวัติการแก้ไขข่าวสาร ปรับปรุงอินเตอร์เฟส (ปุ่มการแสดง) และข้อมูลการแสดงผลหน้าตารางให้เหมาะสมยิ่งขึ้น",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.7",
            "date": "2024-01-20",
            "changes":[
                'เพิ่มรายละเอียดบนสัญลักษณ์เจ้าหน้าที่ในหน้าแผนที่เมื่อทำการไลฟ์สตรีมมิ่ง ( Badge "LIVE" ) และเพิ่มช่องทางในการดูถ่ายทอดสดได้จากหน้าแผนที่เพื่อความสะดวกในการใช้งาน (ทั้ง Center และมือถือ)',
                "เพิ่มตัวเลือกในการซ่อนหรือแสดงหมวดหมู่ย่อยของจุดสนใจหรือเหตุการณ์ในหน้าคัดกรอง (มือถือ)",
                "ปรับปรุงรูปแบบไอคอนเจ้าหน้าที่ : นำขีดแสดงสถานะของเจ้าหน้าที่ออก",
                "ปรับปรุงประสิทธิภาพการกด Push to talk หาเจ้าหน้าที่ระหว่างดูถ่ายทอดสดให้ใช้งานได้ดียิ่งขึ้น (Center)",
                "ปรับปรุงประสิทธิภาพการถ่ายทอดสดบนมือถือให้ใช้งานได้ดียิ่งขึ้น ( เนื่องจากก่อนหน้านี้มีผลกระทบกับ Android version 10 และ 11 )",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.6",
            "date": "2023-12-02",
            "changes":[
                "เพิ่มประสิทธิภาพการเรียกดูข้อมูลแผนที่ยุทธการให้มีความรวดเร็วมากยิ่งขึ้น",
                "ข้อมูลรอตรวจสอบ ปรับปรุงการดึงข้อมูลบุคคลที่ส่งมาจากมือถือให้มีความสมบูรณ์ยิ่งขึ้น",
                "สรุปรายงานเหตุการณ์ ปรับปรุงการแสดงผลกราฟแท่งและกราฟวงกลมให้รองรับในทุกๆมาตราส่วนของจอภาพ",
                "รายละเอียดเจ้าหน้าที่ เพิ่มการแสดงชื่อภารกิจที่กำลังปฏิบัติอยู่บนมือถือ",
                "เพิ่มการแสดงคำนำหน้าชื่อหรือยศของเจ้าหน้าที่ในทุกๆจุดที่มีการแสดง ชื่อ - นามสกุล ของเจ้าหน้าที่",
                "หน้ารายละเอียดเจ้าหน้าที่ เพิ่มการแสดงป้ายชื่อ ( Alert , Duress , Suspect ) เพื่อให้ทราบถึงสถานะของเจ้าหน้าที่บนมือถือ",
                "แก้ไขการแสดงผลอินเตอร์เฟสของปุ่ม (โทรศัพท์ , แชท , โทรผ่านเน็ต) ที่หายไปเมื่อกดดูรายละเอียดเจ้าหน้าที่บนหน้าแผนที่",
                "เส้นวาด ปรับปรุงการแสดงตัวเลขบอกระยะ (ความกว้าง x ความสูง) ที่แสดงผลกับมือถือบางรุ่นผิดพลาดอยู่ให้สมบูรณ์มากยิ่งขึ้น"
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.5",
            "date": "2023-10-31",
            "changes":[
                "การขอความช่วยเหลือ ปรับปรุงการแสดงผลหน้าต่างแจ้งเตือนขอความช่วยเหลือให้สมบูรณ์ยิ่งขึ้น (ชื่อ, หน่วย, พื้นที่, โทร, MGRS, Lat, Lng, เวลา )",
                "การขอความช่วยเหลือ เพิ่มการส่งแจ้งเตือนขอความช่วยเหลือ เมื่อเจ้าหน้าที่เข้าระบบด้วยรหัส Duress Alert",
                "หน้าจัดการการขอความช่วยเหลือ ปรับสีการแสดงป้ายชื่อ สถานะ Duress Alert จากสีแดงเป็นสีม่วง ",
                "หน้ารายละเอียดภารกิจ ปรับปรุงการแสดงผลการเรียกดูรูปภาพให้สมบูรณ์ยิ่งขึ้น",
                "เพิ่มความเร็วในการโหลดข้อมูลแผนที่ยุทธการบนมือถือ",
                "เพิ่มความเร็วในการโหลดข้อมูลหน้ารายการภารกิจบนมือถือ",
                "การโทรด้วยซิมผ่านแอพพลิเคชั่น เพิ่มเงื่อนไขให้ไม่สามารถโทรออกได้กรณีเจ้าหน้าที่ไม่ระบุเบอร์โทรศัพท์",
                "หน้าแผนที่ ปรับปรุงเรื่องสิทธิ์การแสดงชื่อหน่วยงานขณะมีการเรียกดูข้อมูลเจ้าหน้าที่บนหน้าแผนที่",
                "เพิ่มข้อความ ”กำลังตรวจสอบข้อมูล” กรณีที่กำลังมีการโหลดข้อมูลอยู่ (หน้ารายการภารกิจ รายการข่าวสาร รายการเหตุการณ์) บนมือถือ",
                "ปรับปรุงการแสดงชั้นข้อมูล จังหวัด อำเภอ ตำบล ในหน้าแผนที่ให้แสดงผลได้ถูกต้อง",

            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.4",
            "date": "2023-10-29",
            "changes":[
                "เพิ่มประสิทธิภาพการโหลดข้อมูลเข้าระบบครั้งแรกของ Center ให้มีความรวดเร็วยิ่งขึ้น เพื่อตอบโจทย์การใช้งานในกรณีต่าง ๆ (เช่นผู้ใช้งานใหม่ , ล้างฐานข้อมูล , หรือสลับไอดีเข้าใช้งานในเครื่องเดียวกัน)",
                "ปรับปรุงกระบวนการโหลดข้อมูลของมือถือให้มีประสิทธิภาพดียิ่งขึ้น",
                "เพิ่มจำนวนจำกัดของการโหลดข้อมูลเป็น 200 รายการสำหรับหน้าข้อมูลรอตรวจสอบ และเพิ่มจำนวนจำกัดการโหลดข้อมูลเป็น 1,000 รายการสำหรับหน้าต่างเพิ่มจุดสนใจหรือเพิ่มเจ้าหน้าที่ในภารกิจ เพื่อเพิ่มความสะดวกในการใช้งาน",
                "ข้อมูลยานพาหนะ เพิ่มการแสดงข้อมูลเลขเครื่องยนต์ลงในระบบ ซึ่งจะมีการแสดงในหน้าต่าง ๆ ( หน้าข้อมูลรอตรวจสอบ, หน้ารายการยานพาหนะ, หน้ารายละเอียดยานพาหนะ, หน้ารายการการพบเจอยานพาหนะ, หน้ารายละเอียดการพบเจอยานพาหนะ, การค้นหายานพาหนะของมือถือ, หน้าต่างบันทึกยานพาหนะของมือถือ, การเพิ่มการพบเจอยานพาหนะของมือถือ )",
                "หน้ารายละเอียดประวัติพิกัดบุคคลและยานพาหนะ > แก้ไขการแสดงผลข้อมูลให้สอดคล้องกับรายละเอียดของหน้าข้อมูลรอตรวจสอบ",
                "หน้าสร้างภารกิจ เพิ่มฟีเจอร์ให้สามารถเชิญเจ้าหน้าที่หน่วยข้างเคียงหรือหน่วยงานนอกสายเข้าร่วมปฏิบัติภารกิจได้ พร้อมปรับปรุงหน้าต่างการใช้งานให้ตอบโจทย์ผู้ใช้งานมากยิ่งขึ้น",
                "หน้าภารกิจ เพิ่มประสิทธิภาพการเรียกดูข้อมูลภารกิจที่มีเนื้อหาหรือรายละเอียดของภารกิจจำนวนมากให้มีความรวดเร็วยิ่งขึ้น",
                "หน้าระบบสนทนา เพิ่มประสิทธิภาพการเรียกดูข้อมูลห้องแชทให้สามารถประมวลผลได้รวดเร็วยิ่งขึ้น",
                "ระบบสนทนา ปรับสิทธิ์การเริ่มต้นสนทนาของ Operator ให้สามารถเริ่มสนทนาได้เฉพาะเจ้าหน้าที่ Officer หน่วยตนเองและหน่วยใต้สายเท่านั้น",
                "ปรับการแสดงรูปโปรไฟล์ตั้งต้นบนมือถือ กรณีไม่ได้ระบุรูปโปร์ไฟล์ของหน่วยงานหรือเจ้าหน้าที่",
                "รายละเอียดของเหตุการณ์ เพิ่มการแสดงผลหน่วยงานที่สร้างเหตุการณ์และหน่วยงานที่มีสิทธิ์ในการมองเห็นเหตุการณ์",
                "ข่าวสารและเหตุการณ์ เพิ่มประสิทธิภาพและปรับเปลี่ยนวิธีการแสดงผล ป้ายกำกับ “ใหม่” และ “อัปเดต” ให้มีความสมบูรณ์ยิ่งขึ้น",
                "สร้างหรือแก้ไขเส้นวาด เพิ่มการแจ้งเตือนขณะมีการแก้ไขเส้นวาดแล้วกดออกโดยยังไม่ได้บันทึกข้อมูลเส้นวาด",
                "หน้าตรวจสอบยานพาหนะ > รายการรอส่ง ปรับเปลี่ยนการแสดงผลของข้อความให้จำแนกได้ง่ายยิ่งขึ้นระหว่างข้อความที่ผู้ใช้งานกรอกเองกับข้อความที่เป็นตัวอย่าง",
                "ปรับการแสดงผลรูปตั้งต้นของไอคอนจุดสนใจ ป้องกันกรณีไม่ได้ระบุประเภทจุดสนใจหรือไม่สามารถโหลดข้อมูลประเภทจุดสนใจได้",
                "การใช้งานและการแสดงผลแถบภารกิจบนมือถือ ปรับปรุงประสิทธิภาพการใช้งานให้สมบูรณ์ยิ่งขึ้น ( การแสดงผลของ ป้ายกำกับ “ใหม่” และ “อัปเดต”, การแสดงผลของ ปุ่ม เปิด - ปิด การปฏิบัติภารกิจ, ปรับวิธีการส่งพิกัดขณะเจ้าหน้าที่ปฏิบัติภารกิจอยู่แล้วถูกย้ายเครื่อง , ย้ายหน่วย และล้างฐานข้อมูล )",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.3",
            "date": "2023-09-12",
            "changes":[
                "เพิ่มประสิทธิภาพในการคัดกรองจุดสนใจให้สามารถประมวลผลได้เร็วยิ่งขึ้น",
                "หัวข้อปรับแต่งค่าของศูนย์ควบคุม เพิ่มการตั้งค่ารูปแบบแผนที่ (ปกติ, ดาวเทียม, ดาวเทียมผสม, ภูมิประเทศ, แผนที่ทหาร) ให้สามารถเลือกแสดงเป็นค่าเริ่มต้นใช้งานได้",
                "เพิ่มความเร็วในการประมวลผลการแสดงแผนที่ยุทธการ บนหน้าแผนที่ของศูนย์ควบคุม",
                "การโหลดข้อมูลครั้งแรก เพิ่มกระบวนการโหลดข้อมูลรูปแบบใหม่ให้สามารถทำได้ต่อเนื่อง เพื่อรองรับกรณีเกิดปัญหาของสัญญาณอินเทอร์เน็ตหรือการเกิดปัญหาต่างๆ ระหว่างมีการโหลดข้อมูล บนศูนย์ควบคุมและมือถือ",
                "เพิ่มฟีเจอร์การเลื่อนดูรูปภาพเพิ่มเติมบนหน้ารายละเอียดบุคคล",
                "เพิ่มการแสดงผลจุดสนใจในภารกิจรูปแบบใหม่ ให้สามารถแยกระหว่างจุดสนใจตามหน้าที่ของตนเองกับจุดสนใจส่วนกลางได้",
                "ปรับปรุงประสิทธิภาพการโหลดข้อมูลครั้งแรกก่อนใช้งานแอปพลิเคชันให้รวดเร็วยิ่งขึ้น",
                "เพิ่มกระบวนการสำรองข้อมูลเส้นวาด เพื่อรองรับกรณีมีการย้ายเครื่องหรือล้างฐานข้อมูล (ต้องเป็นข้อมูลเส้นวาดที่ถูกบันทึกในระบบเท่านั้น)",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.2",
            "date": "2023-08-14",
            "changes":[
                "ปรับการแสดงผลหน้าต่างแจ้งเตือน “การเชื่อมต่อไม่เสถียร” ให้อยู่ในรูปแบบของ Toast Message (การแสดงกล่องข้อความแจ้งเตือนขนาดเล็ก)",
                "การดูวิเคราะห์การลาดตะเวน เพิ่มกราฟิกเพื่อแสดงทิศทางการเคลื่อนที่ในฝั่ง Center",
                "เพิ่มประสิทธิภาพการซูมรูปภาพทั้งฝั่ง Center และมือถือ",
                "การสร้างแผนที่ยุทธการ เพิ่มฟีเจอร์การเลือกแสดงเส้นแบ่งเขตจังหวัด อำเภอ ตำบล และสามารถ Export ออกมาเพื่อนำไปวาดแผนที่ยุทธการต่อได้",
                "เส้นวาด ปรับการแสดงผลตัวเลขทศนิยมของระยะเส้นวาดจาก 2 ตำแหน่งเป็น 3 ตำแหน่ง",
                "ค้นหาประวัติพิกัด เพิ่มระบบประมวลผลโดยรวมพิกัดที่บันทึกในโหมดออนไลน์และออฟไลน์เข้าด้วยกัน ทำให้สามารถแสดงพิกัดย้อนหลังเป็นภาพรวมได้ในโหมดเดียว (เฉพาะบนมือถือ)",
                "ค้นหาเจ้าหน้าที่ในมือถือ เพิ่มการสรุปจำนวนเจ้าหน้าที่บนหน้าแผนที่",
                "โหมดป้ายชื่อ เพิ่มการแสดงชื่อที่แสดงในแผนที่บรรทัด 1 และชื่อแสดงในแผนที่บรรทัด 2 ได้สูงสุด 12 ตัวอักษรในฝั่งมือถือ",
                "ปรับปรุงขนาดของไอคอนป้ายชื่อให้เหมาะสมต่อการใช้งาน",
                "ปรับปรุงประสิทธิภาพของการเรียกดูจุดสนใจบนมือถือ",
                "ข้อมูลจุดสนใจ เพิ่มการแสดงวันที่อัปเดตล่าสุดของจุดสนใจให้ผู้ใช้งานทราบ",
                "การใช้งานเส้นวาด เพิ่มการไฮไลท์ปุ่มของโหมดวาดเส้น เมื่อมีการใช้งานเส้นวาดอยู่",
                "ไอคอนเจ้าหน้าที่รูปแบบสัญลักษณ์ทางทหาร ปรับปรุงประสิทธิภาพการแสดงผลให้สมบูรณ์ยิ่งขึ้น",
                "หน้ารายละเอียดของเหตุการณ์ฝั่งมือถือ แก้ไขไอคอนรูปแผนที่เป็นไอคอนรูปหมุดพิกัด",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.1",
            "date": "2023-08-04",
            "changes":[
                "เพิ่มการจำแนกสีของเส้นแบ่งเขต จังหวัด อำเภอ ตำบลในหน้าแผนที่",
                "การแสดงผลหน้าแผนที่ ปรับปรุงประสิทธิภาพของระยะในการซูมเข้าและออกของหน้าแผนที่ให้มีความละเอียดมากยิ่งขึ้น",
                "การแสดงพิกัดวิเคราะห์การลาดตะเวน รวบโหมดการแสดงพิกัดลาดตะเวนแบบออฟไลน์และแบบออนไลน์เข้าด้วยกัน ให้สามารถแสดงผลพร้อมกันได้ เพื่อให้ง่ายต่อการวิเคราะห์ข้อมูล",
                "ข้อมูลภารกิจ เพิ่มประสิทธิภาพการใช้งานของภารกิจให้สามารถเพิ่มเจ้าหน้าที่ในภารกิจได้สูงสุดถึง 400 คน และปรับปรุงประสิทธิภาพการโหลดข้อมูลให้รวดเร็วยิ่งขึ้น",
                "รายการจุดสนใจ เพิ่มคอลัมน์การแสดงรายการแก้ไขล่าสุด ให้แสดงที่หน้าตารางข้อมูลจุดสนใจ",
                "ข้อมูลเจ้าหน้าที่ ชื่อแสดงในแผนที่บรรทัด 1 และชื่อแสดงในแผนที่บรรทัด 2 เพิ่มการใส่ตัวอักษรได้สูงสุด 12 ตัวอักษร",

            ],
            "moreInfo":[]
        },
        {
            "version": "v2.1.0",
            "date": "2023-07-15",
            "changes":[
                "การดูข้อมูลย้อนหลังบนหน้าแผนที่ เพิ่มสัญลักษณ์แจ้งเตือนเพื่อแสดงถึงข้อมูลที่ทำการคัดกรองไว้",
                "หน้าข้อมูลรอตรวจสอบ เปลี่ยนรูปแบบสีของปุ่ม “บันทึกข้อมูล” และป้ายแสดงสถานะของบุคคล ยานพาหนะให้ชัดเจนยิ่งขึ้น",
                "ห้องสนทนา เพิ่มป้ายแสดงข้อมูล วัน เดือน ปี ให้ผู้ใช้งานเกิดความเข้าใจได้ง่ายขึ้น",
                "การเลือกดูแผนที่ยุทธการบนหน้าแผนที่ เพิ่มระบบนำทางให้เลื่อนหน้าจอไปยังตำแหน่งของแผนยุทธการที่เลือกโดยอัตโนมัติ",
                "ข้อมูลข่าวสาร เพิ่มให้สามารถคัดลอก หัวข้อข่าวสาร รายละเอียด และรูปภาพของข่าวสาร ไปสร้างเหตุการณ์ได้",
                "หน้ารายละเอียดยานพาหนะ ปรับปรุงชื่อของปุ่มใช้งานจาก “ลบ” เป็น “ล้างค่า” และ ชื่อปุ่ม “เพิ่มยานพาหนะ” เป็น “บันทึกข้อมูล”",
                "เพิ่มประสิทธิภาพการแสดงผลจุดสนใจที่ทำการค้นหาด้วยระบบ Quick Search",
                "หน้ารายละเอียดเจ้าหน้าที่ ปรับปรุงการแสดงผลของวันสิ้นสุดภารกิจให้ชัดเจนยิ่งขึ้น",
                "เพิ่มประสิทธิภาพการทำงานของการรวมกลุ่มข้อมูล (Collection list) ในหน้าแผนที่ให้ดียิ่งขึ้น",
                "หน้ารายละเอียดจุดสนใจ ปรับปรุงหน้าจอผู้ใช้ให้สะดวกต่อการใช้งานมากขึ้น",
                "เปลี่ยนข้อความของปุ่ม จาก “OK” เป็น “ตกลง”",
                "เพิ่มประสิทธิภาพการค้นหาประเภทจุดสนใจในหน้าแผนที่ ให้สามารถค้นหาหมวดหมู่หลักของจุดสนใจได้",
                "เปลี่ยนสีการแสดงผลของข้อความที่เป็นตัวเลือกอันตราย เช่น “คืนค่าเครื่อง” และ “ลบ Database” เป็นอักษรสีแดง",
                "เพิ่มปุ่มรีเฟรชข้อมูลที่หน้ารายการต่างๆ ดังนี้ รายละเอียดเจ้าหน้าที่ รายละเอียดจุดสนใจ รายละเอียดบุคคล รายละเอียดข่าวสาร รายละเอียดเหตุการณ์ รายละเอียดยานพาหนะ รายละเอียดการพบเจอยานพาหนะ รายละเอียดรายงานประจำวัน และรายละเอียดภารกิจ",
                "ปรับปรุงการแสดงผลตัวเลือกคัดกรองเหตุการณ์หน้าแผนที่ให้ตอบโจทย์การใช้งานมากยิ่งขึ้น",
                "เปลี่ยนชื่อตัวเลือกหลักจาก “LiveStream Data” เป็น “ดูการถ่ายทอดสด” และ “Video Directory” เป็น “ประวัติการถ่ายทอดสด”",
                "หน้าประวัติการถ่ายทอดสด เพิ่มให้สามารถคัดกรองด้วยวันที่ได้",
                "การค้นหาเหตุการณ์ เพิ่มให้สามารถเลือกคัดกรองประเภทความมั่นคงได้",
                "ปรับปรุงหน้าจอผู้ใช้เกี่ยวกับการเลือกช่วงเวลาให้เป็นมาตรฐานเดียวกัน",
                "เพิ่มป้าย “ใหม่” และ “อัปเดต” เพื่อบ่งบอกถึงสถานะของข่าวสารและเหตุการณ์ นั้นๆ",
                "ปรับปรุงการทำงานเมื่อเรียกดูห้องสนทนาในมือถือให้มีประสิทธิภาพมากยิ่งขึ้น",
                "เพิ่มฟีเจอร์คัดลอกข้อความจากห้องแชทในมือถือ",
                "ปรับปรุงการแสดงผลโหมดป้ายชื่อและสัญลักษณ์ทางทหารหน้าแผนที่ให้มีสีของสถานะเจ้าหน้าที่เด่นยิ่งขึ้น",
                "ปรับปรุงการแสดงผลช่องจังหวัด อำเภอ และตำบล ที่หน้ารายละเอียดจุดสนใจและเหตุการณ์ของมือถือ เพื่อให้ตอบโจทย์การใช้งานมากยิ่งขึ้น",
                "เพิ่มประสิทธิภาพการทำงานเมื่อเรียกดูรายละเอียดภารกิจของมือถือให้แสดงได้รวดเร็วยิ่งขึ้น",
                "เพิ่มปุ่ม Select All หน้าเลือกชั้นข้อมูลแผนที่ยุทธการของมือถือ",
                "รายการถ่ายทอดสดย้อนหลัง ปรับปรุงประสิทธิภาพเมื่อเรียกดูรายการถ่ายทอดสดย้อนหลังให้ตอบสนองได้รวดเร็วยิ่งขึ้น",
                "ค้นหาพิกัด เพิ่มฟีเจอร์การวางข้อความให้สามารถแบ่งประเภทของ ละติจูด และ ลองจิจูด ได้โดยการกดวางครั้งเดียว",
                "เส้นวาด ปรับปรุงอินเตอร์เฟส (หน้าจอผู้ใช้) ให้ปรับตามลักษณะการแสดงผลของแต่ละอุปกรณ์",
                "ปรับปรุงการแสดงผลหน้าเลือกแผนที่ยุทธการของมือถือ ให้ตอบโจทย์การใช้งานมากยิ่งขึ้น",
                "ปรับปรุงหน้าต่างแจ้งเตือนต่างๆ ให้มีความเด่นชัดมากยิ่งขึ้น",
                "เพิ่มประสิทธิภาพของตัวแอปพลิเคชัน AMO ให้ตอบโจทย์การใช้งานบนอุปกรณ์ IPAD และ Tablet ได้ดียิ่งขึ้น"
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.0.4",
            "date": "2023-06-29",
            "changes":[
                "ปรับปรุงการใช้งานโทรผ่านอินเทอร์เน็ต",
                "ปรับปรุงการแสดงผลของแผนที่ยุทธการ",
                "เพิ่มประสิทธิภาพในการตรวจสอบข้อมูลบุคคล",
                "เพิ่มประสิทธิภาพในการคัดกรองข้อมูลเจ้าหน้าที่",
                "ปรับปรุงการแสดงผลโดยรวมของระบบ",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.0.3",
            "date": "2023-06-25",
            "changes":[
                "ปรับปรุงประสิทธิภาพในการดูประวัติพิกัดของมือถือ",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.0.2",
            "date": "2023-06-23",
            "changes":[
                "หน้าแผนที่เพิ่มประสิทธิภาพในการวิเคราะห์ข้อมูลการลาดตระเวนทั้งแบบ Online และ Offline",
                "หน้าแผนที่เพิ่มประสิทธิภาพในการแสดงผลของเส้นวาดในรูปแบบต่างๆ",
                "หน้ารายละเอียดยานพาหนะเพิ่มการเรียกดูประวัติการแก้ไข",
                "หน้ารายละเอียดบูคคลเพิ่มการเรียกดูประวัติการแก้ไข",
                "เพิ่มประสิทธิภาพในการติดตามข้อมูลใหม่",
                "เพิ่มประสิทธิภาพในการแสดงพิกัดย้อนหลัง",
                "ปรับปรุงการแสดงผลของแถบเมนูซ้ายมือ",
                "ปรับปรุงการแสดงผลของเส้นวาดในมือถือ",
                "ปรับปรุงการแสดงผลเจ้าหน้าที่หน้าแผนที่ในมือถือ",
                "หน้ารายละเอียดโปรไฟล์เพิ่มช่องใส่ข้อมูลตนเอง",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.0.1",
            "date": "2023-05-21",
            "changes":[
                "หน้ารายละเอียดยานพาหนะ เพิ่มการเลือกจังหวัดทะเบียนรถเป็น “ต่างประเทศ” และ “เบตง”",
                "หน้าค้นหายานพาหนะ เพิ่มการค้นหาจังหวัดทะเบียนรถ “ต่างประเทศ” และ “เบตง”",
            ],
            "moreInfo":[]
        },
        {
            "version": "v2.0.0",
            "date": "2023-05-09",
            "changes":[
                "เพิ่มการแสดงไอคอนเจ้าหน้าที่แบบ Tactical Mode เพื่อรองรับการใช้งานในภารกิจปิดล้อม",
                "ปรับปรุงระบบการแสดงผลไอคอนบนแผนที่ สามารถแสดงไอคอน POI และ Incident ได้แบบไม่จำกัดจำนวน",
                "ปรับปรุงระบบสิทธิ์ในการเข้าถึงข้อมูลสำหรับ POI, Incident, ภารกิจ, และแผนยุทธการ เพื่อให้สามารถรองรับชั้นความลับได้ทุกรูปแบบ",
                "สามารถกำหนดภารกิจลับสำหรับการปฏิบัติที่เป็นความลับได้",
                "เพิ่มประเภทจุดสนใจส่วนกลางในภารกิจ เพื่อรองรับการใช้งานที่หลากหลายขึ้น",
                "ปรับปรุงระบบแสดงผลให้สามารถแสดงข้อความเต็มได้เมื่อใช้เมาส์ชี้ กรณีที่ข้อความนั้นแสดงบนหน้าจอไม่ครบเพราะมีความยาวเกินพิกัด",
                "เพิ่มประสิทธิภาพในการคำนวณและสรุปจำนวนของข้อมูลต่าง ๆ (จุดสนใจ แผนที่ยุทธการ, ประเภทจุดสนใจ, เหตุการณ์ ในหน้าแผนที่) เมื่อมีการเรียกดู",
                "เพิ่มประสิทธิภาพในการแสดงผลของข้อมูลบนหน้าแผนที่ (เช่น แผนที่ยุทธการ, ประเภทจุดสนใจ, เหตุการณ์) ทำให้สามารถแสดงผลบนแผนที่ได้เร็วขึ้น",
                "ปรับรูปแบบการแสดงผล วัน เดือน ปี ทั้งหมดในระบบจาก คริสต์ศักราช (ค.ศ.) เป็น พุทธศักราช (พ.ศ.) เพื่อให้สอดคล้องกับการใช้งานร่วมกับระบบราชการของไทย",
                "เพิ่มตัวคัดกรองในการค้นหาข้อมูลในหน้าการแบ่งประเภทจุดสนใจให้สามารถทำการคัดกรองได้ง่ายขึ้น",
                "เพิ่มหน้าการแบ่งประจุดสนใจในภารกิจ เพื่อรองรับการใช้งานร่วมกับ Tactical Mode",
                "ปรับปรุงการแสดงผลของแผนที่ยุทธการ และ แผนที่ทางทหาร ให้ทำงานร่วมกันได้อย่างบูรณาการ",
                "เพิ่มนโยบายความปลอดภัยในการตั้งรหัสผ่านให้มีความรัดกุมยิ่งขึ้น",
                "ปรับปรุงการแสดงสีบ่งบอกสถานะของเจ้าหน้าที่บนแผนที่ให้รองรับการใช้งานได้หลากหลายขึ้น",
                "เพิ่มฟังก์ชั่นการแสดงรัศมีของหมุดที่ปักบนแผนที่ เพื่อรองรับการใช้งานเชิงยุทธการ",
                "เพิ่มความสามารถในการรองรับไฟล์ที่ส่งในระบบสนทนา ให้สามารถรับ-ส่ง ไฟล์เอกสาร ที่จำเป็นต่อการปฏิบัติงานได้ เช่นไฟล์ ppt, pdf, zip",
                "เพิ่มตัวเลือกในการคัดกรองข้อมูลในหน้าค้นหาเจ้าหน้าที่ ให้สามารถระบุการค้นหาเจ้าหน้าที่ในสายการบังคับบัญชาที่ต้องการได้",
                "ปรับปรุงมาตรการความปลอดภัยในการเรียกดูวิดีโอสตรีมมิ่งให้มีความรัดกุมยิ่งขึ้น",
                "ปรับปรุงประสิทธิภาพในการรับแจ้งเตือนการขอความช่วยเหลือจากเจ้าหน้าที่ให้ทำงานได้ดีขึ้น",
                "ปรับปรุงการแสดงผลจำนวนการออนไลน์ของเจ้าหน้าที่ ให้ตอบสนองกับการใช้งานมากยิ่งขึ้น",
                "เพิ่มตัวเลือกสถานะของข้อมูลบุคคลให้ตอบสนองกับการใช้งานมากยิ่งขึ้น",
                "เพิ่มประสิทธิภาพการค้นหาข้อมูลพื้นที่จากละติจูดและลองจิจูด ในหน้าจุดสนใจและเหตุการณ์",
                "เพิ่มประสิทธิภาพการแสดงผลของรัศมีกับหมุดในหน้าจุดสนใจและเหตุการณ์",
                "เพิ่มช่องทางในการค้นหาข้อมูลหน้าการแบ่งประเภทเหตุการณ์",
                "ปรับปรุงการแสดงผลของรายการภารกิจ ในหน้าภารกิจ ให้สามารถแยกภารกิจที่เสร็จสิ้นแล้วและยังปฏิบัติอยู่ได้ง่ายขึ้น (ภารกิจที่เลยวันสิ้นสุดแล้วจะแสดงวันเป็นสีเหลือง)",
                "ปรับปรุงรูปแบบการจัดเก็บข้อมูลข่าวสารให้รองรับการใช้งานได้ดียิ่งขึ้น",
                "ปรับปรุงการแสดงผลรายการข้อมูลข่าวสารในกรณีพิเศษ (แสดงสีสถานะข่าว Duress)",
                "เพิ่มช่องทางในการค้นหาข้อมูลหน้าข่าวสาร",
                "ปรับปรุงประสิทธิถาพในการทำงานของระบบโดยรวมให้มีความเสถียรมากขึ้น",
                "เพิ่มระบบสร้างจุดสนใจในภารกิจ ให้เจ้าหน้าที่สามารถสร้าง, แก้ไข, และแชร์ข้อมูลจุดสนใจได้จากมือถือ",
                "ปรับปรุงหน้ารายละเอียดภารกิจให้สามารถแสดงและค้นหาจุดสนใจในภารกิจได้",
                "เพิ่มความสามารถในการรองรับการทำงานในภารกิจลับ",
                "เพิ่มความสามารถในการรองรับการปฏิบัติภารกิจร่วมกันระหว่างหน่วยงาน (Joint operation)",
                "เพิ่มฟังก์ชั่นำหรับบันทึกและส่งพิกัด GPS โดยอัตโนมัติ เมื่อปฏิบัติภารกิจ (Auto เก็บพิกัดลงเครื่องเวลากดปฏิบัติภารกิจ)",
                "เพิ่มประสิทธิภาพในการแสดงผลของหน้าแผนที่ ให้สามารถแสดงข้อมูลจุดสนใจ และเหตุการณ์จำนวนมากได้",
                "เพิ่มความสามารถในการรองรับไฟล์ที่ส่งในระบบสนทนา ให้สามารถรับ-ส่ง ไฟล์เอกสาร ที่จำเป็นต่อการปฏิบัติงานได้ เช่นไฟล์ ppt, pdf, zip",
                "ปรับปรุงระบบค้นหาเจ้าหน้าที่ ให้สามารถหาด้วยคีย์เวิดจาก ชื่อ, นามสกุล, ชื่อบนแผนที่บรรทัด 1, หรือชื่อบนแผนที่บรรทัด 2 ก็ได้",
                "ปรับปรุงการแสดงรูปภาพ ให้รองรับการแสดงรูปในสัดส่วนต่าง ๆ ได้อย่างเหมาะสม",
                "ปรับปรุงรูปลักษณ์และดีไซน์ของแอปพลิเคชันโดยรวมทั้งระบบ ให้มีความทันสมัยและใช้งานสะดวกขึ้น",
                "เพิ่มการแนะนำระบบ AMO เบื้องต้น เมื่อเข้าใช้งานครั้งแรก",
                "เพิ่มระบบโทรศัพท์ผ่านอินเตอร์เน็ต (VOIP) ให้เจ้าหน้าที่ในระบบสามารถโทรหากันผ่านระบบ AMO ได้",
                "เพิ่มความสามารถในการแสดงไอคอนเจ้าหน้าที่แบบ Tactical Mode เพื่อรองรับการใช้งานในภารกิจปิดล้อม ",
                "เพิ่มประสิทธิภาพในการคัดกรองจุดสนใจบนแผนที่ ให้สามารถคัดกรองจุดสนใจได้จาก ชื่อหมวดหมู่, ประเภทจุดสนใจ, และชื่อจุดสนใจ",
                "เพิ่มโหมดการแสดงขอบเขตพื้นที่ในแผนที่ เช่น ขอบเขตจังหวัด  อำเภอ ตำบล",
                "เพิ่มความสามารถในการแสดงไอคอนเจ้าหน้าที่ด้วยสัญลักษณ์ทางทหาร",
                "เพิ่มประสิทธิภาพในการคัดกรองเหตุการณ์ ให้สามารถคัดกรองได้จาก ชื่อหมวดหมู่, ประเภทเหตุการณ์, และชื่อเหตุการณ์",
                "เพิ่มประสิทธิภาพในการคัดกรองข่าวสาร ให้สามารถคัดกรองข่าวสารได้จากคีย์เวิร์ด และช่วงเวลาประกาศข่าว",
                "เพิ่มความสามารถในการรองรับการแบ่งหมวดหมู่ด้วยประเภทความมั่นคงของข่าวสารและเหตุการณ์",
                "เพิ่มการแสดงชื่อหน่วยงานหรือเจ้าหน้าที่ที่ได้รับข่าวสารแต่ละฉบับ",
                "เพิ่มประสิทธิภาพในการคัดกรองเหตุการณ์ ให้สามารถคัดกรองเหตุการณ์ได้จากคีย์เวิร์ดและช่วงเวลาเกิดเหตุ",
                "เพิ่มตัวเลือกการคัดกรองรายงานประจำวัน ให้สามารถคัดกรองแบบระบุหน่วยงาน หรือดูหน่วยงานใต้สังกัดทั้งหมดได้",
                "เพิ่มระบบสร้างสัญลัษณ์บนแผนที่แบบรวดเร็ว ให้สามารถสร้างรูปทรงเช่น วงกลม, สี่เหลี่ยม, ระยะยิง รวมถึง สัญลักษณ์พื้นฐานต่าง ๆ เพื่อใช้ร่วมกับการปฏิบัติ และสามารถแชร์ให้ศูนย์ควบคุม, สมาชิกในภารกิจ, หรือเจ้าหน้าที่อยู่ในสังกัดได้",
                "ปรับปรุงระบบให้รองรับการบันทึกได้โดยไม่ต้องระบุสถานที่พบเจอ",
                "ปรับปรุงการทำงานของหน้าค้นหาบุคคล กรณีค้นหาใบหน้าไม่พบ สามารถนำภาพมาเพิ่มบุคคลใหม่ได้ทันที",
                "เพิ่มความสามารถในการการปรับโหมดแนวนอนระหว่างถ่ายทอดสด",
                "เพิ่มความสามารถในการสลับกล้องหน้าและกล้องหลังระหว่างถ่ายทอดสด",
                "เพิ่มประสิทธิภาพของระบบถ่ายทอดสด ให้การรับ-ส่งภาพมีความเถียรมากขึ้น โดยมีความคมชัดมากขึ้นด้วย",
                "เพิ่มการยืนยันตัวตนโดยรูปถ่ายใบหน้า และระบบความปลอดภัยในการบริหารจัดการข้อมูลสำคัญ (<- เช่น กัน abuse email เพิ่ม ความSecure password)",
                "เพิ่มการแสดงตัวอย่างไอคอนที่จะปรากฏบนแผนที่ เมื่อกรอกข้อมูลในหน้าลงทะเบียน",
                "ปรับปรุงระบบเพื่อรองรับการเก็บข้อมูลตาม PDPA Act (พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล)"
            ],
            "moreInfo":[]
        },
        {
            "version": "v1.4.0",
            "date": "2021-11-06",
            "changes":[
                "หน้าแผนที่ สามารถค้นหาประวัติพิกัดของตัวเองที่บันทึกไว้ในเครื่องได้",
                "การค้นหาประวัติพิกัด สามารถเปิด-ปิดเส้นแสดงการเดินทางได้",
                "เปลี่ยนหมุดแสดงพิกัดในประวัติพิกัดให้มีขนาดเล็กลง",
                "หน้ารายงานประจำวัน เพิ่มตัวเลือกในการค้นหาด้วยภารกิจและหน่วยงาน",
                "หน้าดูการถ่ายทอดสด เพิ่มปุ่มกดสำหรับ Push to Talk ไปยังเจ้าหน้าที่ที่ถ่ายทอดอยู่",
                "หน้าถ่ายทอดสด สามารถรับการ Push to Talk จากผู้ดูการถ่ายทอดสดได้"
            ],
            "moreInfo":[]
        },
        {
            "version": "v1.3.0",
            "date": "2021-08-01",
            "changes":[
                "ปรับปรงระบบแผนที่เข็มทิศสามารถบันทึกและส่งต่อการวาดได้",
                "ปรับปรุงระบบบันทึกยานพาหนะ สามารถบันทึกและค้นหาเลขตัวถังได้",
                "เพิ่มหัวข้อ เกี่ยวกับ AMO เพื่อดูคู่มือวีดีโอการใช้งาน และการดาวน์โหลด",
                "ย้ายปุ่มส่งพิกัดออฟไลน์มาอยู่หน้าเมนูหลัก",
                "สามารถแชร์ข่าวสารได้"
            ],
            "moreInfo":[
                {
                    "type":"video", 
                    "name":"วีดีโอการใช้งานระบบแผนที่เข็มทิศแบบใหม่", 
                    "link":"/"
                },
                {
                    "type":"document",
                    "name":"คู่มือการใช้งาน(เพิ่มเติม)",
                    "link":"/"
                }
            ]
        },
        {
            "version": "v1.2.2",
            "date": "2021-06-21",
            "changes":[
                "เพิ่มหัวข้อหน่วยงานในหน้ารายงานประจำวัน",
                "เพิ่มพิกัด MGRS ในหน้าขอความช่วยเหลือฉุกเฉิน",
                "แก้ไขข้อบกพร่องอื่นๆ"
            ],
            "moreInfo":[
            ]
        },
        {
            "version": "v1.2.1",
            "date": "2021-06-21",
            "changes":[
                "เพิ่มสถานะการดาวน์โหลดข้อมูลในหน้าล็อคอิน",
                "แก้ไขข้อบกพร่องอื่นๆ"
            ],
            "moreInfo":[
            ]
        },
        {
            "version": "v1.2.0",
            "date": "2021-03-06",
            "changes":[
                "ปรับปรุงระบบบันทึกบุคคลและยานพาหนะ สามารถเพิ่มการพบเจอได้",
                "เพิ่มระบบแผนที่และข็มทิศ",
                "เพิ่มการดูถ่ายทอดสดจากมือถือ",
                "เพิ่มการดูพิกัดย้อนหลังจากมือถือ",
                "เพิ่มระบบรายงานประจำวัน",
                "ปรับปรุงการล็อคอินให้รวดเร็วขึ้น",
                "เพิ่ม ไอคอนบรรทัด1 และ ไอคอนบรรทัด2",
                "สามารถเลือกศุนย์ควบคุมได้ในหน้าล็อคอิน"
            ],
            "moreInfo":[
                {
                    "type":"video", 
                    "name":"วีดีโอการใช้งานระบบแผนที่เข็มทิศแบบใหม่", 
                    "link":"/"
                },
                {
                    "type":"document",
                    "name":"คู่มือการใช้งาน(เพิ่มเติม)",
                    "link":"/"
                }
            ]
        }
    ]

    // useEffect(() => {
    //     async function fetchData() {
    //         const res = await fetch("data/changeLogs.json");
    //         const json = await res.json();
    //         setReleaseNote(json);
    //     }
    //     fetchData();
    // }, []);

    const onClickLink = (data) => {
        setStep(1);
        setLink(data);
    }
    const onClickBack = () => {
        setStep(0);
        setLink(null);
    }

    return (
        <div>
            <Grow in={true} timeout={400}>
                <Box padding={3} paddingTop={3}>
                    <img src={logo} alt="AMO" className="video-tutorial-header-logo" />
                    <Typography variant="h5" style={{color:"#ffffff", display:"inline"}}>มีอะไรใหม่ในระบบ AMO</Typography>
                    
                    <Box m={3}/>
                    {
                        releaseNote.map((obj, index) => (
                            <div key={index} style={{display: (new Date(obj.date) - new Date()) > 0 ? "none" : "block"}}>
                                <Typography className="change-log-text" variant="subtitle1">
                                    เวอร์ชัน: {obj.version} 
                                    {
                                        (Math.ceil(Math.abs(new Date(obj.date) - new Date()) / (1000 * 60 * 60 * 24)) < 7) ?
                                        <div class="badge pulsate">new</div> : ''
                                    }
                                </Typography>
                                <Typography className="change-log-text" variant="subtitle1">วันที่: {dayjs(obj.date).format("DD MMMM BBBB")}</Typography>
                                <Typography className="change-log-text" variant="body1">การเปลี่ยนแปลง:</Typography>
                                <List dense>
                                    {
                                        obj.changes.map((changeText, index)=>(
                                            <ListItem key={index}>
                                                
                                                <ListItemIcon style={{minWidth: "30px"}}>
                                                    <AddBoxRoundedIcon style={{color:"white"}} fontSize='small'/>
                                                </ListItemIcon>
                                                <ListItemText className="change-log-text" key={index}>
                                                    {changeText}
                                                </ListItemText>
                                            </ListItem>
                                            
                                        ))
                                    }
                                </List>
                                <Divider className="hrFade" style={{marginTop: '20px', marginBottom: '20px'}}/>
                                {/* <hr className="hr-download"/> */}
                            </div>
                        ))
                    }
                </Box>
            </Grow>
        </div>
    );
}

export default ChangeLog;
